
export enum SaleType {
  Mono= 'Mono',
  BundleMonoVersion= 'BundleMonoVersion',
  BundleMultiVersion= 'BundleMultiVersion',
  MonoToScrap= 'MonoToScrap',
  BundleMonoVersionToScrap= 'BundleMonoVersionToScrap',
  BundleMultiVersionToScrap= 'BundleMultiVersionToScrap',

}